import '../scss/main.scss';

$(document).ready(function() {

    /* =================================================================
    * スムーススクロール
    * ================================================================= */
    $(function () {
    $('a[href^="#"]').on('click', function (e) {
        const href = $(this).attr('href');
        const $target = href === '#' || href === '' ? $('html') : $(href);

        if (!$target.length) return;

        e.preventDefault();

        const position = $target.offset().top;

        $('html, body').animate(
        { scrollTop: position },
        600,
        'swing'
        );
    });
    });

    // ========== hamburger menu ==========
    $('.hamburger').on('click', function() {
        $(this).toggleClass('active');
        $('.mobile_nav').toggleClass('active');
        $('.nav_overlay').toggleClass('active');
        $('body').toggleClass('nav-open');
    });

    // オーバーレイクリックで閉じる
    $('.nav_overlay').on('click', function() {
        $('.hamburger').removeClass('active');
        $('.mobile_nav').removeClass('active');
        $('.nav_overlay').removeClass('active');
        $('body').removeClass('nav-open');
    });

    // ナビリンククリックで閉じる
    $('.mobile_nav a').on('click', function() {
        $('.hamburger').removeClass('active');
        $('.mobile_nav').removeClass('active');
        $('.nav_overlay').removeClass('active');
        $('body').removeClass('nav-open');
    });

    // ========== header scroll ==========
    const $header = $('header');

    // ========== footer accordion ==========
    $('.footer_nav > ul > li').on('click', function(e) {
        if ($(e.target).is('a')) return;
        $(this).toggleClass('open');
        $(this).children('.child').stop().slideToggle(300);
    });

    window.addEventListener('scroll', function() {
        let scrollPos = window.scrollY || document.documentElement.scrollTop;
        if (scrollPos > 100) {
            $header.addClass('scrolled');
        } else {
            $header.removeClass('scrolled');
        }
    }, { passive: true });

    // ========== スクロールアニメーション ==========
    $(window).on('scroll', function() {
        $('.flip-in, .under-in, .roll-in').each(function() {
            var elementTop = $(this).offset().top;
            var viewportBottom = $(window).scrollTop() + $(window).height();
            if (elementTop < viewportBottom - 200) {
                $(this).addClass('visible');
            }
        });
    });

    // モバイル用
    window.addEventListener('touchmove', function() {
        // 必要に応じて処理を追加
    }, { passive: true });
});

// ========== header 移動 ==========
jQuery(function($){
    const $header = $('.top_header');
    const switchPoint = window.innerHeight;
    const mobileBreakpoint = 768;

    function handleScroll() {
        if (window.innerWidth <= mobileBreakpoint) {
            $header.removeClass('is-side');
            return;
        }

        if ($(window).scrollTop() > switchPoint) {
            $header.addClass('is-side');
        } else {
            $header.removeClass('is-side');
        }
    }

    $(window).on('scroll resize', handleScroll);
});

// ========== smartphone cta button animation ==========
jQuery(function($){
    const mobileBreakpoint = 768;
    const $cta = $('.recruit_cta');
    let scrollTimer = null;

    function handleScroll() {
        // PCサイズなら何もしない
        if (window.innerWidth > mobileBreakpoint) return;

        // スクロール中は非表示
        $cta.removeClass('is-visible');

        clearTimeout(scrollTimer);

        // スクロール停止後300msで表示
        scrollTimer = setTimeout(function() {
            $cta.addClass('is-visible');
        }, 300);
    }

    $(window).on('scroll', handleScroll);
});

/* =================================================================
 * Infinite Slider：二列の無限ループスライダー
 * ================================================================= */
(function infiniteSlider($){
    $(document).ready(function() {
        $('.slider-track').each(function() {
            const $track = $(this);
            const $items = $track.children().clone();
            $track.append($items);
        });
    });
})(jQuery);
